import { render } from "./payroll-list.vue?vue&type=template&id=2f0336a6&scoped=true"
import script from "./payroll-list.vue?vue&type=script&lang=js"
export * from "./payroll-list.vue?vue&type=script&lang=js"

import "./payroll-list.vue?vue&type=style&index=0&id=2f0336a6&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0336a6"]])

export default __exports__